<template>
    <div class="contentwrapper">
        <slot />
    </div>
</template>
